export enum QueryKeyName {
  HrocRegionalManagerKpisComments = 'hroc-regional-manager-kpis-comments',
  ShifthandoverComments = 'shifthandover-comments',
  ShifthandoverEventsSearch = 'events-search',
  ShifthandoverChangeFunctions = 'shifthandover-change-functions',
  ShifthandoverEventsSearchInfiniteQuery = 'shifthandover-events-search-infinite-query',
  ShifthandoverEventsCountPerStatus = 'shifthandover-events-count-per-status',
  KpiResultServiceGetKpisByTypes = 'kpis-by-types',
  WorkerOrdersByRevisionCode = 'work-orders-by-revision-code',
  KpisMonthlyTrendsByTypes = 'kpis-monthly-trends-by-types'
}
